import { useAssetDetailsContext } from "@/pages/asset-details/context/assetDetailsContext";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import { makeStyles } from "@material-ui/core/styles";
import { useSearchParams } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiSelect-root": {
			backgroundColor: "#FFF",
		},
	},
	formControl: {
		width: "100%",
	},
}));

type Props = {};

export const TypesFilter = ({}: Props) => {
	const classes = useStyles();
	const {
		state: { typeCodes },
	} = useAssetDetailsContext();
	const [searchParams, setSearchParams] = useSearchParams();

	const type = searchParams.get("type") ?? "";

	const handleFilter = (e: any) => {
		searchParams.set("type", e.target.value);
		setSearchParams(searchParams, { replace: true });
	};

	return (
		<div className={classes.root}>
			<FormControl
				variant="outlined"
				margin="dense"
				className={classes.formControl}
			>
				<InputLabel id="types-select-label">Types</InputLabel>
				<Select
					labelId="types-select-label"
					id="types-select"
					value={type}
					onChange={handleFilter}
					label="Types"
				>
					{typeCodes.map((type) => {
						return (
							<MenuItem key={`logId-${type.id}`} value={type.id}>
								<Grid container alignItems="center">
									{type.description}
								</Grid>
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
		</div>
	);
};
